import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { EmailSend } from '../../types/Types';


export const useSendEmail = (
  options?: UseMutationOptions<EmailSend, unknown, EmailSend, unknown>
) => {
  return useMutation({
    ...options,
    mutationFn: (data: EmailSend) =>
      axiosInstance
        .post(getAPIURL('/Email/Send'), data)
        .then((res) => res.data),
  });
};
